<template>
  <div>
    <button
      class="btn btn-white btn-sm"
      @click="showModal()"
    >
      Change Domain Name
    </button>
    <b-modal
      v-model="show"
      hide-footer
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      title="Change Domain Name"
    >
      <p>
        To change the domain name for {{ name }}, make a selection
        from the list below, and then click <b>Save Domain Name</b>.
      </p>
      <b-select
        v-model="domain"
        :options="options"
      ></b-select>
      <hr>
      <div class="d-flex justify-content-between">
        <button
          class="btn btn-primary btn-sm"
          @click="save()"
          :disabled="saving"
        >
          Save Domain Name
        </button>
        <button
          class="btn btn-link"
          @click="cancel()"
          :disabled="saving"
        >
          Cancel
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { changeDomainName } from '../api'

export default {
  props: {
    userId: {
      type: [String, Number],
      required: true,
    },
    website: {
      type: Object,
      required: true,
    },
    options: {
      type: Array,
      required: true
    },
    name: {
      type: String,
      required: true,
    }
  },
  data () {
    return {
      saving: false,
      show: false,
      domain: this.website.domain,
    }
  },
  methods: {
    showModal () {
      this.show = true
    },
    cancel () {
      this.show = false
    },
    async save () {
      this.saving = true
      try {
        let response = await changeDomainName(this.userId, this.website, this.domain)
        this.saving = false
        this.show = false
        this.$emit('changed', this.domain)
      } catch (e) {
        console.error(e)
      } finally {
      }
    }
  }
}
</script>